import styled from 'styled-components';
import Line4Steps from '../../assets/svg/SVGComponents/Line4Steps';

interface IStepProps {
  $accomplished: boolean;
  $positionX?: number;
  $positionY?: number;
}

interface IStepBarProps {
  $steps: number;
}

export const Container = styled.div`
  padding: 0;
  width: 100%;
  position: relative;
`;

export const Background = styled.div`
  width: 100%;
  @media (max-width: 2560px) {
    /* ou outro valor que se adeque melhor */
  }
`;

export const ResponsiveLine4Steps = styled(Line4Steps)`
  min-width: 32rem;

  @media (max-width: 768px) {
    width: 90%; /* ou outro valor que se adeque melhor */
  }

  @media (max-width: 425px) {
    min-width: 30rem;
    width: 80%; /* ou outro valor que se adeque melhor */
  }

  @media (max-width: 375px) {
    min-width: 25rem;
    width: 90%; /* ou outro valor que se adeque melhor */
  }
`;

export const Steps = styled.div<IStepBarProps>`
  width: 100%;
  height: 100%;
  position: ${props => (props.$steps === 1 ? 'relative' : 'absolute')};
  top: ${props => (props.$steps === 1 ? 'auto' : '50%')};
  left: ${props => (props.$steps === 1 ? 'auto' : '50%')};
  transform: ${props =>
    props.$steps === 1 ? 'none' : 'translate(-50%, -50%)'};
  display: ${props => (props.$steps === 1 ? 'flex' : 'block')};
  justify-content: ${props => (props.$steps === 1 ? 'center' : 'initial')};
  align-items: ${props => (props.$steps === 1 ? 'center' : 'initial')};
  padding: ${props => (props.$steps === 1 ? '2rem 0' : '0')};
`;

export const Step = styled.div<IStepProps>`
  position: ${props =>
    props.$positionX !== undefined ? 'absolute' : 'relative'};
  left: ${props =>
    props.$positionX !== undefined ? `${props.$positionX}px` : 'auto'};
  top: ${props =>
    props.$positionY !== undefined ? `${props.$positionY}px` : 'auto'};
  transform: ${props =>
    props.$positionX !== undefined ? 'translate(-50%, -50%)' : 'none'};

  > span {
    width: 250%;
    top: -2.2rem;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    position: absolute;
    font-family: 'RedHatDisplay-ExtraBold';
    font-size: 0.61rem;
    letter-spacing: 0.12rem;
    margin-bottom: 1.4rem;
  }

  > div {
    width: 3.9rem;
    height: 3.9rem;
    background-color: ${props => (props.$accomplished ? '#4CAF50' : '#f2f2f2')};
    transition: background-color 0.4s ease;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    > p {
      width: 0.12rem;
      height: 1.22rem;
      background-color: ${props =>
        props.$accomplished ? '#4CAF50' : '#f2f2f2'};
      transition: background-color 0.4s ease;
      position: absolute;
      top: -1.22rem;
      left: 50%;
      transform: translateX(-50%);
    }

    > button {
      width: 3.3rem;
      height: 3.3rem;
      border-radius: 50%;
      outline: ${props =>
        props.$accomplished ? '2px solid #FFFEFC' : '2px solid #b7b7b7'};
      transition: outline 0.4s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      > svg {
        stroke: ${props => (props.$accomplished ? '#FFFEFC' : '#b7b7b7')};
        transition: stroke 0.4s ease;
      }
    }
  }

  @media (max-width: 425px) {
    > div {
      width: 3.6rem;
      height: 3.6rem;

      > button {
        width: 2.9rem;
        height: 2.9rem;
      }
    }
  }

  @media (max-width: 375px) {
    > div {
      width: 3.2rem;
      height: 3.2rem;

      > button {
        width: 2.5rem;
        height: 2.5rem;
      }
    }
  }
`;
